import AttachmentDataProviderItem from 'owa-service/lib/contract/AttachmentDataProviderItem';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import GetAttachmentDataProviderItemsResponse from 'owa-service/lib/contract/GetAttachmentDataProviderItemsResponse';

export function createAttachmentDataProviderItemsResponse<TItem>(
    items: TItem[],
    createAttachmentDataProviderItem: (item: TItem) => AttachmentDataProviderItem
): GetAttachmentDataProviderItemsResponse {
    return {
        TotalItemCount: items.length,
        ResultCode: AttachmentResultCode.Success,
        Items: items.map(item => createAttachmentDataProviderItem(item)),
    };
}

export function createFailedAttachmentDataProviderItemsResponse(
    errorCode: AttachmentResultCode
): GetAttachmentDataProviderItemsResponse {
    return {
        TotalItemCount: 0,
        ResultCode: errorCode,
        Items: [],
    };
}
